exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-component[data-v-716ffe4c]{padding-top:20px}.color-component .component-title[data-v-716ffe4c]{font-size:16px;font-weight:600;color:#303133;margin-bottom:20px;padding-bottom:10px;border-bottom:1px solid #f0f0f0}.color-component .form-content .el-form-item[data-v-716ffe4c]{margin-bottom:20px}.color-component .action-buttons[data-v-716ffe4c]{margin-top:30px;text-align:center}.color-component .action-buttons .el-button[data-v-716ffe4c]{margin:0 10px;padding:10px 30px}", ""]);

// exports
